import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    area: '',
    experiencia: '',
    cidade: '',
    material: '',
    whatsapp: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4op4hhfcjnktac9qd2g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          area: '',
          experiencia: '',
          cidade: '',
          material: '',
          whatsapp: '',
          email: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12">
          {/* Left Column */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
              Entre em Contato
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-8">
              Preencha o formulário com suas informações e entraremos em contato para iniciar seu processo seletivo na AAPEQ.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#F05954] flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#262364] mb-1">Localização</h3>
                  <p className="text-sm text-gray-600">Presencial obrigatório - Vagas limitadas</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#262364] flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#262364] mb-1">Processo Seletivo</h3>
                  <p className="text-sm text-gray-600">Avaliação criteriosa de cada candidato</p>
                </div>
              </div>
            </div>

            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pelo+site+%E2%80%94+Se%C3%A7%C3%A3o+Contato+%E2%80%94+QUERO+MINHA+VAGA+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#20BA5A] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              <span>WhatsApp: QUERO MINHA VAGA</span>
            </a>

            <div className="mt-8">
              <a
                href="https://instagram.com/aapeq"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#262364] hover:text-[#F05954] transition-colors"
              >
                <i className="ri-instagram-line text-2xl"></i>
                <span className="text-sm font-medium">Mensagem no Instagram: "QUERO MINHA VAGA"</span>
              </a>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="lg:col-span-3">
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form className="bg-gray-50 rounded-3xl p-8 lg:p-10">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    required
                    value={formData.nome}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                    placeholder="Seu nome"
                  />
                </div>

                <div>
                  <label htmlFor="area" className="block text-sm font-medium text-gray-700 mb-2">
                    Área de Atuação *
                  </label>
                  <select
                    id="area"
                    name="area"
                    required
                    value={formData.area}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                  >
                    <option value="">Selecione</option>
                    <option value="Ator/Atriz">Ator/Atriz</option>
                    <option value="Músico/Cantor">Músico/Cantor</option>
                    <option value="DJ">DJ</option>
                    <option value="Dançarino">Dançarino</option>
                    <option value="Atleta">Atleta</option>
                    <option value="Lutador">Lutador</option>
                    <option value="Diretor">Diretor</option>
                    <option value="Professor">Professor</option>
                    <option value="Mestre">Mestre</option>
                    <option value="Treinador">Treinador</option>
                    <option value="Estudante">Estudante</option>
                  </select>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="experiencia" className="block text-sm font-medium text-gray-700 mb-2">
                    Tempo de Experiência *
                  </label>
                  <input
                    type="text"
                    id="experiencia"
                    name="experiencia"
                    required
                    value={formData.experiencia}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                    placeholder="Ex: 5 anos"
                  />
                </div>

                <div>
                  <label htmlFor="cidade" className="block text-sm font-medium text-gray-700 mb-2">
                    Cidade *
                  </label>
                  <input
                    type="text"
                    id="cidade"
                    name="cidade"
                    required
                    value={formData.cidade}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                    placeholder="Sua cidade"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="material" className="block text-sm font-medium text-gray-700 mb-2">
                  Link do Material (portfólio, vídeo, etc.)
                </label>
                <input
                  type="url"
                  id="material"
                  name="material"
                  value={formData.material}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                  placeholder="https://"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-700 mb-2">
                    WhatsApp *
                  </label>
                  <input
                    type="tel"
                    id="whatsapp"
                    name="whatsapp"
                    required
                    value={formData.whatsapp}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                    placeholder="(00) 00000-0000"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#F05954] transition-colors text-sm"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#262364] text-white py-4 rounded-xl font-semibold hover:bg-[#1a1845] transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Candidatura'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl">
                  <p className="text-sm text-green-800 text-center">
                    ✓ Candidatura enviada com sucesso! Entraremos em contato em breve.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl">
                  <p className="text-sm text-red-800 text-center">
                    ✗ Erro ao enviar. Por favor, tente novamente.
                  </p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
